import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Inject,
  ViewChild,
  OnChanges,
  SimpleChanges,
  ElementRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { EMPTY, Observable, Subject, Subscription, throwError } from 'rxjs';
import { catchError, filter, first, map, tap } from 'rxjs/operators';
import { ModalRef, ModalService } from '@purespectrum1/ui/modal';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-timezone';

import { BuyerApiService } from '../shared/services/buyer-api/survey.service';
import { BuyerEntryLinkViewModalComponent } from './buyer-entry-link-view-modal/buyer-entry-link-view-modal.component';
import { CsvToJsonService } from '../shared/services/common-service/csv-to-json.service';
import { AuthService } from '../shared/services/auth/auth.service';
import { BuyerConfigService } from '../create-surveys/services/buyer-config/buyer.config.service';
import { Constants } from '../shared/constants/buyer-constant';
import {
  Quotas,
  Criteria,
  Qbp,
  PsidsBuyerUploadListResponse,
  PSIDs,
  PsidsUploadRefListResponse,
  NcSettings,
  PatchSurveyInterface,
  UniqueLinks,
} from '../shared/interfaces/survey.interface';
import {
  TimeZone,
  SelectDate,
  SelectTime,
  FilterDateRange,
} from '../shared/interfaces/date';

import { BuyerSettingsService } from '../shared/services/buyer-settings-service/buyer-settings-service.service';
import { notifyMessage } from '../shared/constants/notify-message';
import { GlobalConstants } from '../shared/constants/global.constants';
import { SURVEY_STATUS } from '../shared/constants/survey-status';
import { SurveyMetaDataService } from '../shared/services/survey-meta-data/survey-meta-data.service';
import { STEPPER_BUTTON_STATUS } from '../shared/constants/stepper-button-status';
import { SharedDataService } from '../shared/services/shared-data-service/shared-data-service';
import {
  IncludePostPayload,
  IncludePsidApiResponse,
  SurveyPayload,
} from '../shared/interfaces/survey-meta-data.interface';
import { SurveyStatus } from '../shared/utils/survey-status';
import { ClearOrViewPsidModalComponent } from './clear-or-view-psid-modal/clear-or-view-psid-modal.component';
import {
  CreateSurveyService,
  LiveUrlAndTestUrl,
} from '../create-surveys/create-survey.service';
import { EventEmitterService } from '../shared/services/event-emitter/event-emitter.service';
import { SurveyPayloadService } from '../create-surveys/survey-payload.service';
import { UserService } from '../shared/services/user-service/user.service';
import { ProjectManagers } from '../shared/interfaces/user.interface';
import {
  BuyerSurveyResponse,
  ClearPsidsResponse,
} from '../shared/interfaces/survey.interface';
import { ConfirmationModalComponent } from '../shared/ui/confirmation-modal/confirmation-modal.component';
import { TemplateService } from '../shared/services/template/template.service';
import { TemplateResponse } from '../create-surveys/layout/template-modal/template-modal.interface';
import { AuthState } from '../shared/interfaces/auth.interface';
import { EnvironmentConfig } from '../shared/interfaces/environment.interface';
import { MarketplaceService } from '../create-surveys/marketplace.service';
import { FooterComponent } from '../create-surveys/layout/footer/footer.component';
import { Router } from '@angular/router';
import { SurveyLaunch } from '../shared/interfaces/survey-launch.interface';
import { IncludeListComponent } from './include-list/include-list.component';
import {
  DateRange,
  DaterangepickerOption,
  LocaleLanguageCountry,
} from '../create-surveys/shared/interfaces/feasibility.interface';
import { CommonService } from '../shared/services/common-service/common-service';
import { GetBuyerConfigResponse } from '../create-surveys/shared/interfaces/operator-settings.interface';
import { DaterangepickerComponent } from 'ng2-daterangepicker';
import { BillingSpaceValidator } from '../shared/validators/survey/billing-space-validator';
import { BillingRulesService } from '../shared/services/billing-rules/billing-rules-service';
import { BillingNumberRules } from '../shared/interfaces/billing-rules.interfaces';
import { SurveyUpdateError } from '../shared/services/buyer-api/domain/survey-update-error';
import { MissingMarkersModalComponent } from '../shared/ui/missing-markers-modal/missing-markers-modal.component';
import { Multicountry } from '../shared/interfaces/create-surveys.interface';

@Component({
  selector: 'ps-ui-survey-launch',
  templateUrl: './survey-launch.component.html',
  styleUrls: ['./survey-launch.component.css'],
})
export class SurveyLaunchComponent implements OnInit, OnDestroy, OnChanges {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;
  @Input() set auth(data: AuthState) {
    this._auth.setState(data);
  }
  @Input() surveyId: number;
  @Input() isInsight: boolean = false;
  @Input() finalizeInitialValues: Partial<SurveyLaunch> = {};
  @Input() disableLiveURLField!: boolean;
  @Input() disableTestURLField!: boolean;
  @ViewChild(FooterComponent) footer: FooterComponent;
  @ViewChild('dateRangeFilterRef', { read: DaterangepickerComponent })
  private _dateRangeFilterRef: DaterangepickerComponent;
  @ViewChild('basicToken') basicToken!: ElementRef;
  form!: FormGroup;
  private _missingMarkerModelRef: ModalRef<MissingMarkersModalComponent> | null =
    null;
  private _subscriptions: Subscription = new Subscription();
  public userType: string = '';
  public surveyDatails = <BuyerSurveyResponse>{};
  public userDetails!: any;
  public buyerEntryLinkUploaded: boolean = false;
  public buyerEntryLinksArr: Array<string> = [];
  public buyerEntryLinkInfo = Constants.FILE_LINKS;
  public warningTestFlg: boolean = false;
  public warningFlg: boolean = false;
  public showTransIdWarningMsg: boolean = false;
  public showNonHttpsWarningMsg: boolean = false;
  public testUrlCheck: boolean = false;
  public liveUrlCheck: boolean = false;
  public surveyGroupingBeforeUIChange!: number[];
  public checkWithUserUrl: string = '';
  public regexAmprsnd = new RegExp('\\&transaction_id', 'g');
  public regexQustionMrk = new RegExp('\\?transaction_id', 'g');
  public pmEmailFieldDisplay: boolean = false;
  public hours: SelectTime[] = [];
  public minutes: SelectTime[] = [];
  public tzNames: TimeZone[] = [];
  public qbpSelectionQuotas: QbpSelectionQuota[] = [];
  public qbpSelectedQuotaCategory: string = '';
  public feotFields = {
    feotQuantity: Constants.FEOT_INFO.DEFAULT_QUANTITY,
    feotRemainingTime: Constants.FEOT_INFO.DEFAULT_REMAINING_TIME,
  };
  public includePostPayload = {
    fromDate: '',
    toDate: '',
    surveyIds: [] as Array<number>,
  };
  public buyerSettings = {
    ps_psid: '',
    ps_status: '',
    ps_hash: '',
    ps_supplier_id: '',
    ps_transaction: '',
    ps_transaction_id2: '',
    ps_transaction_id3: '',
    ps_transaction_id4: '',
  };
  public scheduleLaunchSlideDisable: boolean = false;
  public scheduleLaunchDisable: boolean = false;
  public softLaunchDisable: boolean = false;
  public softLaunchSlideDisable: boolean = false;
  public fieldOverTimeDisable: boolean = false;
  public footerButtonStatus: number = STEPPER_BUTTON_STATUS.FINALIZE_AND_LAUNCH;
  public enableNightcrawler: boolean = false;
  public showDQBattery: boolean = false;
  public enableViewByPM: boolean = false;
  public isSurveySyncedOnNC: boolean = false;
  public ncSettings!: NcSettings | undefined;
  public showIncludeToo: boolean = false;
  public manageEdit: boolean = false;
  public inclExclDisable: boolean = true;
  public inclExclBuyerUpload: boolean = false;
  public isMulticountrySurvey: boolean = false;
  public isEnableMarginMaxForBuyer: boolean = false;
  public isEnableBillingNumberRulesForBuyer: boolean = false;
  private _psids: Array<PSIDs> = [];
  private _includePsids: string[] = [];
  public surveyGroupingPSIDUpload: boolean = false;
  public billingRules$: Observable<BillingNumberRules>;
  public billingRules?: BillingNumberRules;

  fileName: string = '';
  file!: File;
  private _fdata: FormData = new FormData();
  public isQbpSliderDisabled: boolean = false;
  public isQlcSliderDisabled: boolean = false;
  public surveyPayload: SurveyPayload = {} as SurveyPayload;
  public operatorProjectManagers: ProjectManagers[] = [];
  public buyerProjectManagers: ProjectManagers[] = [];
  public isServiceOperator: boolean = false;
  public isBuyerLinkSliderDisabled: boolean = false;
  public selectedTemplateResponse?: TemplateResponse;
  private _initDone = false;
  private _isServiceBuyerLoggedIn: boolean = false;
  public buyerPmLabel: string = '-- Assign Project Manager --';
  public feotPacings = ['Hours', 'Days', 'Weeks'];
  public filterDateRange: DateRange = {};
  public filterByDatapickerOptions: DaterangepickerOption;
  public enableFilteringByDate: boolean = false;
  public surveyStatus = SurveyStatus;
  public notEditableBasicToken: boolean = true;
  public showSuccessTooltip: boolean = false;
  public fixedBasicTokenValue: string | undefined;
  public enableProjectLevelDataQuality: boolean = false;
  public enableMandatoryBillingNumber = false;
  public loggedInAsServiceBuyer = false;
  public isClickSurvey: boolean = false;
  private _locale: LocaleLanguageCountry;

  private _surveyCompanySubject = new Subject<number>();

  constructor(
    @Inject('ENV') private _env: EnvironmentConfig,
    private _router: Router,
    private _fb: FormBuilder,
    private _buyerApiService: BuyerApiService,
    private _toastr: ToasterService,
    private _modal: ModalService,
    private _csvToJson: CsvToJsonService,
    private _auth: AuthService,
    private _buyerSettingsService: BuyerSettingsService,
    private _datepipe: DatePipe,
    private _surveyMetaDataService: SurveyMetaDataService,
    private _sharedDataService: SharedDataService,
    private _createSurveyService: CreateSurveyService,
    private _eventEmitterService: EventEmitterService,
    private _surveyPayloadService: SurveyPayloadService,
    private _userService: UserService,
    private _templateService: TemplateService,
    private _marketplaceService: MarketplaceService,
    private _commonService: CommonService,
    private _buyerConfigService: BuyerConfigService,
    private _billingRulesService: BillingRulesService
  ) {
    this.userType = this._auth.userType;
  }

  ngOnInit(): void {
    if (this.userType === 'operator') {
      this.buyerPmLabel = '-- Assign Buyer Project Manager --';
    }
    if (this._auth.buyerConfig?.includeToo) {
      this.enableFilteringByDate = true;
    }
    this._auth.loggedInAsServiceBuyer$.subscribe((loggedIn: boolean) => {
      if (loggedIn) {
        this.loggedInAsServiceBuyer = true;
      }
    });

    this.enableMandatoryBillingNumber =
      this._auth.buyerConfig?.enableMandatoryBillingNumber ?? false;

    this.isEnableBillingNumberRulesForBuyer =
      this._auth.buyerConfig?.enableBillingNumberRules ?? false;

    this._createDateRangePickerOption();
    this._getSurveyDetails();
    this.userDetails = this._auth.user;
    this._getBuyerInfo(this.userDetails.cmp);
    this.showIncludeToo = this._checkFeatureAccess('includeToo');
    this.enableProjectLevelDataQuality =
      !!this._auth.buyerConfig?.enableProjectLevelDataQuality;
    this.showDQBattery = !!this._auth.buyerConfig?.enableSurveyDQBattery;
    this.enableNightcrawler = !!this._auth.buyerConfig?.enableNightcrawler;
    this.enableViewByPM = !!this._auth.buyerConfig?.enableViewByPM;

    if (!this.loggedInAsServiceBuyer && this._checkUserIsServiceOperator()) {
      this.enableProjectLevelDataQuality = true;
      this.showDQBattery = true;
    }

    this._generateForm();
    this._assignTimeField();
    this._subscriptions.add(
      this._sharedDataService.getPsidModelClose().subscribe((psidClose) => {
        this.inclExclBuyerUpload = psidClose.close;
      })
    );
    this._subscriptions.add(
      this._createSurveyService.getMultiCountrySurveys().subscribe((data) => {
        if (data?.length) {
          this.isMulticountrySurvey = true;
        }
      })
    );

    this._subscriptions.add(
      this._eventEmitterService.multiCountrySelectionChangeEmitter.subscribe(
        () => {
          if (this.surveyDatails.live_url !== this.form.value.live_url) {
            this._patchSurveyDetail('live_url');
          }
          if (this.surveyDatails.billing_id !== this.form.value.billing_id) {
            this._patchSurveyDetail('billing_id');
          }
        }
      )
    );
    this._subscriptions.add(
      this._auth.loggedInAsServiceBuyer$.subscribe((isLoggedIn) => {
        if (isLoggedIn) {
          this._isServiceBuyerLoggedIn = true;
        }
      })
    );

    this._subscriptions.add(
      this._marketplaceService.invokeUpdateSurvey.subscribe(() => {
        if (!this.manageEdit) {
          // Live Edit
          this.footer?.editSurvey();
        } else {
          // draft
          this.footer?.save('save');
        }
      })
    );

    this._subscriptions.add(
      this._marketplaceService.invokeLaunchSurvey.subscribe(() => {
        if (this.manageEdit) {
          // draft
          this.footer?.launchSurvey();
        }
      })
    );

    this._createSurveyService.setProjectManagerForAllSurveys(
      {} as ProjectManagers
    );
  }

  public checkAndOpenMissingMarkersModal(surveyDetail: BuyerSurveyResponse) {
    if (this._missingMarkerModelRef) {
      return;
    }
    if (surveyDetail.mc_unique_id) {
      this._openMcMissingMarkersModal();
    } else {
      this._openMissingMarkerModal();
    }
  }

  private _openMcMissingMarkersModal() {
    // check against subject returning old/empty mc surveys the first time
    const surveyPresentInMcSurveys = (mcSurveys: Multicountry[]) => {
      return !!mcSurveys.find((survey) => survey.surveyId == this.surveyId);
    };
    this._subscriptions.add(
      this._createSurveyService
        .getMultiCountrySurveys()
        .pipe(first(surveyPresentInMcSurveys))
        .subscribe((mcSurveys) => {
          this._openMissingMarkerModal(mcSurveys);
        })
    );
  }

  private _openMissingMarkerModal(mcSurveys: Multicountry[] = []) {
    this._missingMarkerModelRef = this._modal.open(
      MissingMarkersModalComponent,
      {
        data: {
          isCreated: true,
          displayLocales: this._returnDraftMCLocales(mcSurveys),
          psSurveyId: this._returnFirstMCSurvey(mcSurveys) || this.surveyId,
        },
      }
    );
  }

  private _returnDraftMCLocales(mcSurveys: Multicountry[]): string[] | null {
    if (!mcSurveys.length) {
      return null;
    }
    return mcSurveys
      .filter((mcSurvey) => mcSurvey.psSurveystatus == SURVEY_STATUS.DRAFT)
      .map((mcSurvey) => {
        const {
          pl_code,
          language: { transalte_code },
        } = mcSurvey;
        return `${transalte_code}_${pl_code}`;
      });
  }

  private _returnFirstMCSurvey(mcSurveys: Multicountry[]): number | null {
    if (!mcSurveys.length) {
      return null;
    }
    const sortedSurveys = mcSurveys
      .map((survey) => survey.surveyId!)
      .sort((a, b) => a - b);
    return sortedSurveys[0];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.form) {
      this._generateForm();
    }
    if (changes.surveyId?.currentValue && !changes.surveyId?.firstChange) {
      this._getSurveyDetails();
    }
  }

  private _setBillingNumberRules(): void {
    const buyerCompanyId = this.surveyDatails.buyer_company || 0;

    this.billingRules$ = !this.isEnableBillingNumberRulesForBuyer
      ? EMPTY
      : this._billingRulesService.fetchRules(buyerCompanyId).pipe(
          tap((rules) => {
            this.billingRules = rules;

            if (!this.surveyDatails.billing_id) {
              const billingId =
                !this.billingRules.autoGenerate &&
                this.surveyDatails.ps_survey_status === SURVEY_STATUS.DRAFT
                  ? ''
                  : rules.example;
              this.patchBillingNumber(billingId);
              this.surveyDatails.billing_id = billingId;
            }
          })
        );
  }

  validateAndRemoveSpacesFromBillingNumber(billingNumber: string = '') {
    const validator = new BillingSpaceValidator(billingNumber);
    if (validator.check()) {
      const updatedPo = validator.remove();
      this.patchBillingNumber(updatedPo);
      return this._toastr.error(
        notifyMessage.errorMessage.PO_NUMBER_SPACES_NOT_ALLOWED,
        notifyMessage.errorMessage.PO_NUMBER_SPACE_NOT_ALLOWER_TITLE
      );
    }
    this.patchBillingNumber(billingNumber);
  }

  patchBillingNumber(BilingValue: string) {
    this.form.patchValue({ billing_id: BilingValue });
    this.updatePayload({ billing_id: BilingValue });
  }

  private _checkUserIsServiceOperator(): boolean {
    const serviceOperator =
      this.userDetails.operatorAcssLvls === 'admin' ||
      this.userDetails.operatorAcssLvls === 'serviceOperator'
        ? true
        : false;
    return serviceOperator;
  }

  private _checkFeatureAccess(configToCheck: string) {
    const buyerConfig: any = this._auth.buyerConfig;
    const serviceOperator = this._checkUserIsServiceOperator();
    return serviceOperator || !!(buyerConfig && buyerConfig[configToCheck]);
  }

  private _getAllOperators() {
    const operatorUsersSub = this._userService
      .getAllOperatorUser(false)
      .subscribe(
        (response) => {
          this.operatorProjectManagers = response.users;
          this.operatorProjectManagers.splice(0, 0, {
            email: '',
            name: '-- Assign Project manager --',
            company: 0,
            id: 0,
          });
          if (this.surveyDatails?.pm) {
            const selectedPm = this.operatorProjectManagers.filter(
              (user) => user.id === this.surveyDatails.pm?.id
            )[0];
            this.form.patchValue({ pm: selectedPm });
          }
        },
        (error) => {
          this._toastr.error(error.error.msg);
        }
      );
    this._subscriptions.add(operatorUsersSub);
  }

  private _getAllBuyerUser() {
    const buyerUsersSub = this._userService
      .getAllBuyerUser(this.surveyDatails.buyer_company, false)
      .subscribe(
        (response) => {
          this.buyerProjectManagers = response;
          this.buyerProjectManagers.splice(0, 0, {
            email: '',
            name: this.buyerPmLabel,
            company: 0,
            id: 0,
          });
          if (this.surveyDatails?.bpm) {
            const selectedBpm = this.buyerProjectManagers.filter(
              (user) => user.id === this.surveyDatails.bpm?.id
            )[0];
            this.selectBuyerProjectManager(selectedBpm);
          }
        },
        (error) => {
          this._toastr.error(error.error.msg);
        }
      );
    this._subscriptions.add(buyerUsersSub);
  }

  selectProjectManager(pm: ProjectManagers) {
    if (pm?.id === 0) {
      this.form.patchValue({ pm: {} });
      this.updatePayload({ pm: {} });
    } else {
      this.form.patchValue({ pm });
      this.updatePayload({ pm });
    }
  }

  selectBuyerProjectManager(bpm: ProjectManagers) {
    if (bpm?.id === 0) {
      this.form.patchValue({ bpm: {} });
      this.updatePayload({ bpm: {} });
    } else {
      this.form.patchValue({ bpm });
      this.updatePayload({ bpm });
    }

    if (this.isMulticountrySurvey) {
      this._setGlobalData('bpm', true);
    }
  }

  private _getSurveyDetails() {
    const getSurveyDetails$ = this._buyerApiService
      .getSurveyById(this.surveyId)
      .subscribe(
        async (resp) => {
          if (
            [
              () => resp.ps_survey_status === SURVEY_STATUS.DRAFT,
              () => this.userType === 'operator',
              () => !this._isServiceBuyerLoggedIn,
            ].every((item) => item())
          ) {
            this._router.navigateByUrl('/dashboard');
            return;
          }
          this.surveyDatails = resp;
          if (
            resp.is_decipher_survey &&
            resp.ps_survey_status == SURVEY_STATUS.DRAFT
          ) {
            this.checkAndOpenMissingMarkersModal(resp);
          }
          this.surveyPayload =
            this._surveyPayloadService.mapSurveyDetails(resp);
          this.isClickSurvey = !!this.surveyPayload.click_balancing;
          this._surveyMetaDataService.setSurveyData({
            surveyId: resp.ps_survey_id,
            mcUniqueId: resp.mc_unique_id,
            channel_type: resp.channel_type,
            activeTrafficChannel: resp.is_tc_children_active,
          });
          this._setUniqueLinksData(resp.unique_links);
          this.form.patchValue(this.surveyDatails);
          const billingId = await this._surveyPO(this.surveyDatails);
          this.form.patchValue({
            completes_required: resp.completes_required,
            uniqBuyerEntryLinkFlag: resp.unique_links.enable,
            subscriber_emails: this._getSubscriberEmails(),
            survey_grouping: this._surveyGrouping(this.surveyDatails),
            billing_id: billingId,
            crmId: resp.crmId,
            softLaunch: resp.soft_launch.enable,
          });
          this.patchBillingNumber(billingId);
          this.setLiveUrlInfo(resp.live_url || '');
          this.changeTestUrlInfo(resp.test_url || '');
          this.showFeotFields(resp.is_feot_enabled);
          this._pmEmailFieldDisplay(
            this.surveyDatails.company?.generate_invoice
          );
          this._setBillingNumberRules();
          this._createQbpSelectionQuotas(resp.quotas || []);
          if (
            [
              () => this.form.value.uniqBuyerEntryLinkFlag,
              () => resp.unique_links.items.length,
            ].every((item) => item())
          ) {
            this.buyerEntryLinkUploaded = true;
            const testEntryLink = this.generateEntryLink('link');
            this.form.patchValue({
              test_ps_survey_entry_link: testEntryLink,
              live_url: '',
            });
          }

          this._updateScheduleLaunchInformation(this.surveyPayload);
          this._manageLaunchEnableDisable(resp);
          this._setFilterDateRange();
          this.inclExclDisable =
            this.surveyDatails.incl_excl === 1 ? true : false;
          this._setInclExcl(this.surveyDatails.incl_excl);
          if (this.surveyDatails.ps_survey_status == SurveyStatus.Draft) {
            this.manageEdit = true;
          }
          this._getSelectedTemplateDetails(resp.template_id);

          this.form.patchValue({
            hasPSIDRefList: this.surveyDatails.hasPSIDRefList || false,
          });
          this.isSurveySyncedOnNC = !!this.surveyDatails.live_url;
          this.ncSettings = this.surveyDatails?.nc_settings;
          this.form.patchValue({
            softLaunch: this.surveyDatails.soft_launch.enable || false,
            launchquantity: this.surveyDatails.soft_launch.quantity || '',
          });
          this.launchquantityChange();
          this._loadPsidRefList(this.surveyDatails.hasPSIDRefList);
          this._subscriptions.add(
            this._createSurveyService
              .getLiveUrlForAllSurveys()
              .subscribe((data) => {
                if (data.live_url !== '') {
                  this.form.patchValue({
                    live_url: data,
                  });
                }
              })
          );
          this._patchLiveTestUrl();
          this._initDone = true;
          if (this._auth.userType === 'operator') {
            this._getAllOperators();
            this._verifyCompanySettings(resp.buyer_company);
          }
          this.surveyPayload.basic_token = this.surveyDatails?.basic_token;
          this.fixedBasicTokenValue = this.surveyDatails?.basic_token?.value;
          this._getAllBuyerUser();
          this.setSubscriberEmails();
          this._updateDataQualityPayload();
          this._locale = {
            languageCode: this.surveyDatails.locale.language_code,
            countryCode: this.surveyDatails.locale.country_code,
          };
        },
        (error) => {
          this._toastr.error(error.error.msg);
        }
      );
    this._subscriptions.add(getSurveyDetails$);
  }

  private _getSelectedTemplateDetails(templateId?: number) {
    if (!templateId) {
      return;
    }
    this._templateService.getById(templateId).subscribe((resp) => {
      this.selectedTemplateResponse = resp;
    });
  }

  private _loadPsidRefList(hasPSIDRefList: boolean | undefined) {
    if (!hasPSIDRefList) {
      return;
    }
    this._buyerApiService
      .getBuyerUploadedList(this.surveyId, this.surveyDatails.incl_excl)
      .subscribe((psidsResp: PsidsBuyerUploadListResponse) => {
        if (psidsResp && psidsResp.psids && psidsResp.psids.length) {
          const surveyIds = this._getSurveysIdsFromForm().filter(
            (surveyId) =>
              Number(this.surveyDatails.ps_survey_id) !== Number(surveyId)
          );
          /**
           * INCLUDE case - When PSIDs are available, but survey grouping (excluding self survey) is not there, then
           * it's manual upload case otherwise automatic upload.
           * EXCLUDE case - When PSIDs are avaialable, it automatically means it was manually uploaded because we do
           * not allow PSID upload through date range in exclude case.
           */
          this.inclExclBuyerUpload = !this.inclExclDisable || !surveyIds.length;
          this.surveyGroupingPSIDUpload = !!(
            this.inclExclDisable && surveyIds?.length
          );
          this._psids = psidsResp.psids;
          this._includePsids = psidsResp.psids.map((psid) => psid.PSID);
          this._updateSurveyData();
        }
      });
  }

  private _setUniqueLinksData(uniqueLinkData: UniqueLinks) {
    if (uniqueLinkData.enable) {
      this.setBuyerLinkSliderValue();
      if (uniqueLinkData.items && uniqueLinkData.items.length) {
        this.buyerEntryLinksArr = uniqueLinkData.items
          .map((item) => (item && item.link ? item.link : ''))
          .filter(Boolean);
      }
    }
  }

  public setBuyerLinkSliderValue() {
    if (this.surveyDatails.ps_survey_status !== SURVEY_STATUS.DRAFT) {
      this.isBuyerLinkSliderDisabled = true;
    } else {
      this.isBuyerLinkSliderDisabled = false;
    }
  }

  private _patchLiveTestUrl() {
    this._subscriptions.add(
      this._createSurveyService.getLiveUrlForAllSurveys().subscribe((data) => {
        if (data.live_url !== '') {
          this.form.patchValue({
            live_url: data.live_url || '',
            test_url: data.test_url || '',
          });
        }
      })
    );
  }

  private _generateForm() {
    this.form = this._fb.group({
      uniqBuyerEntryLinkFlag: [false],
      schedule_launch: this._fb.group({
        enable: [true],
        info: [],
      }),
      basic_token: this._fb.group({
        enable: [false],
        value: [''],
      }),
      scheduledLaunchDetails: this._fb.group({
        date: [],
        minutes: [],
        hours: [],
        timezone: [],
      }),
      qbp: this._fb.group({
        enable: [false],
        quota_ids: [],
        selectedQuotaIds: [],
        category: [],
      }),
      qlc: this._fb.group({
        enable: [false],
        multiple_quotas: this._fb.group({
          enable: false,
          count_by_quota: false,
          compensate_by_quota: false,
        }),
      }),
      qbpSelectedQuota: [],
      softLaunch: [false],
      quota_throttling: [false],
      launchquantity: [],
      launchpercentile: [],
      is_feot_enabled: [false],
      survey_external_id: [''],
      completes_required: [],
      field_time: [],
      is_qbp_enable: [false],
      buyerMsg: [],
      subscriber_emails: [],
      live_url: ['', [Validators.required]],
      test_url: [],
      billing_id: [],
      url_transform: [false],
      testUrlTT: [],
      liveUrlTT: [],
      liveWarningMsg: [],
      testWarningMsg: [],
      nonHttpsWarningMsg: [],
      survey_client: [],
      test_ps_survey_entry_link: [],
      survey_grouping: [],
      buyer_message: [],
      pm_emails: [],
      incl_excl: 0,
      hasPSIDRefList: false,
      isSameLiveUrlChecked: [false],
      isSameBillingSurveyPoChecked: [false],
      crmId: [],
      pm: [],
      bpm: [],
      asanaId: [],
      is_dq_enable: !!this._auth.buyerConfig?.enableProjectLevelDataQuality,
      is_enable_margin_max: [false],
      feot: this._fb.group({
        pacing: ['days'],
        interval: [],
        is_custom: [],
      }),
      dq_settings: this._fb.group({
        purescore_filter_enabled:
          !!this._auth.buyerConfig?.enableDefaultSettingsPureScore,
        fp_device_check: !!this._auth.buyerConfig?.enableSettingsFpFraudCheck,
        fp_fraud_check: !!this._auth.buyerConfig?.enableSettingsFpFraudCheck,
      }),
    });
  }

  private _pmEmailFieldDisplay(generateInvoice: string) {
    if (['PO', 'PROJECT'].includes(generateInvoice)) {
      this.pmEmailFieldDisplay = true;
    }
  }

  private async _surveyPO(surveyDatails: BuyerSurveyResponse) {
    if (
      this.surveyDatails.ps_survey_status === SURVEY_STATUS.DRAFT &&
      this.surveyDatails.is_clone_survey &&
      !this.surveyDatails.is_clone_billing_id_changed
    ) {
      const modalRef = this._modal.open(ConfirmationModalComponent, {
        data: {
          text: 'Would you like to use the same PO Number as the original survey? Doing so will combine the data with other surveys that share the same PO Number. Click "No" to enter a new PO Number.',
          cancelButtonLabel: 'Yes',
          confirmButtonLabel: 'No',
        },
        width: '450px',
      });
      const response = await modalRef.onClose$
        .pipe(map((msg) => msg === 'ok'))
        .toPromise();
      if (response) {
        return '';
      }
    }

    const defaultPo = this.billingRules
      ? this.billingRules.example
      : `PS${this.surveyId}`;

    const po = surveyDatails.billing_id ? surveyDatails.billing_id : defaultPo;

    if (
      this.isMulticountrySurvey &&
      this.form.value.isSameBillingSurveyPoChecked
    ) {
      this._createSurveyService.setBillingSurveyPoForAllSurveys(po);
    }

    return po;
  }

  private _surveyGrouping(surveyDatails: BuyerSurveyResponse) {
    let surveyGrouping = surveyDatails.survey_grouping;
    surveyGrouping.push(surveyDatails.ps_survey_id);
    this.surveyGroupingBeforeUIChange = [
      ...new Set(surveyGrouping.map((elem) => elem)),
    ];
    return this.surveyGroupingBeforeUIChange;
  }

  public checkWarnGroupingRemoval() {
    const pristineGrouping = this.surveyGroupingBeforeUIChange;
    const newGrouping = this.form.value.survey_grouping;
    if (pristineGrouping.some((elem) => !newGrouping.includes(elem))) {
      if (!this.enableFilteringByDate) {
        this._toastr.warning(
          notifyMessage.warningMessage.LAUNCH_SURVEY
            .SURVEY_REMOVE_FROM_PRISTINEGROUPING
        );
      }
    }
  }

  private _getSubscriberEmails() {
    return this.surveyDatails.subscriber_emails &&
      this.surveyDatails.subscriber_emails[0]
      ? this.surveyDatails.subscriber_emails
      : this.userDetails.eml;
  }

  public setEntryLinkFlag() {
    const upcomingFlag = !this.form.value.uniqBuyerEntryLinkFlag;
    let testEntryLink = '';
    if (!upcomingFlag) {
      testEntryLink = this.generateEntryLink(this.form.value.live_url || '');
    } else if (this.buyerEntryLinksArr.length) {
      this.buyerEntryLinkUploaded = true;
      testEntryLink = this.generateEntryLink('link');
    }

    if (upcomingFlag) {
      this.form.patchValue({ live_url: '' });
      this.updatePayload({ live_url: '' });
    }

    this.form.patchValue({
      uniqBuyerEntryLinkFlag: upcomingFlag,
      test_ps_survey_entry_link: testEntryLink,
    });
    this.updatePayload({
      unique_links: {
        enable: this.form.value.uniqBuyerEntryLinkFlag,
        items: this.buyerEntryLinksArr,
      },
      test_ps_survey_entry_link: testEntryLink,
    });

    this.warningFlg = false;

    if (!upcomingFlag) {
      this._surveyMetaDataService.saveSurvey();
    }
  }

  public onSameUrlCheckChange() {
    if (this.form.value.live_url?.length) {
      this.form.patchValue({
        isSameLiveUrlChecked: !this.form.value.isSameLiveUrlChecked,
      });
      this._setGlobalData('live_url', true);
    }
  }

  public onBillingCheckChange() {
    if (this.form.value.billing_id?.length) {
      this.form.patchValue({
        isSameBillingSurveyPoChecked:
          !this.form.value.isSameBillingSurveyPoChecked,
      });

      if (this.form.value.isSameBillingSurveyPoChecked) {
        this._createSurveyService.setBillingSurveyPoForAllSurveys(
          this.form.value.billing_id
        );
      }
    }
  }

  private _patchSurveyDetail(key: string) {
    if (this._checkCondition(key)) {
      let patchSurveyPromise = [];
      if (
        key === 'billing_id'
          ? this.form.value.isSameBillingSurveyPoChecked
          : this.form.value.isSameLiveUrlChecked
      ) {
        this._setGlobalData(key, true);
        this._subscriptions.add(
          this._createSurveyService
            .getMultiCountrySurveys()
            .subscribe((data) => {
              patchSurveyPromise = this._patchMultipleSurveys(data, key);
            })
        );
      } else {
        this._setGlobalData(key, false);
        const payload = [
          {
            op: 'replace',
            path: `/${key}`,
            value: this.form.value[key],
          },
        ];

        if (
          key === 'live_url' &&
          this.form.value.test_url !== '' &&
          this.form.value.test_url !== null
        ) {
          payload.push({
            op: 'replace',
            path: `/test_url`,
            value: this.form.value.test_url,
          });
        }
        patchSurveyPromise.push(this._patchSurvey(this.surveyId, payload));
      }
      Promise.allSettled(patchSurveyPromise);
    }
    this.updatePayload();
  }

  private _checkCondition(key: string) {
    let surveyDetailData = '';
    let isChecked = false;
    let keyValue = this.form.value[key];
    if (key === 'billing_id') {
      surveyDetailData = this.surveyDatails.billing_id;
      isChecked = this.form.value.isSameBillingSurveyPoChecked;
    } else {
      surveyDetailData = this.surveyDatails.live_url || '';
      isChecked = this.form.value.isSameLiveUrlChecked;
    }

    if (
      (keyValue !== '' && isChecked) ||
      (keyValue !== '' && keyValue !== surveyDetailData)
    ) {
      return true;
    }
    return false;
  }

  private _patchMultipleSurveys(data: any, key: string) {
    const patchSurveyPromise: any = [];
    data?.forEach((singleSurvey: any) => {
      const payload = [];
      if (singleSurvey.surveyId) {
        payload.push({
          op: 'replace',
          path: `/${key}`,
          value: this.form.value[key],
        });
        //as per requirement in MC-44
        if (key === 'live_url' && this.form.value.test_url !== '') {
          payload.push({
            op: 'replace',
            path: `/test_url`,
            value: this.form.value.test_url,
          });
        }
        patchSurveyPromise.push(
          this._patchSurvey(singleSurvey.surveyId, payload)
        );
      }
    });
    return patchSurveyPromise;
  }

  private _setGlobalData(key: string, isMultiChecked: boolean) {
    let valueToSet: string | LiveUrlAndTestUrl =
      key === 'billing_id'
        ? this.form.value[key]
        : {
            live_url: this.form.value[key] || '',
            test_url: this.form.value.test_url || '',
          };

    if (!isMultiChecked) {
      valueToSet = key === 'billing_id' ? '' : { live_url: '', test_url: '' };
    }
    if (key === 'billing_id') {
      this._createSurveyService.setBillingSurveyPoForAllSurveys(
        valueToSet as string
      );
    } else if (key === 'live_url') {
      this._createSurveyService.setLiveUrlForAllSurveys(
        valueToSet as LiveUrlAndTestUrl
      );
    } else if (key === 'bpm') {
      this._createSurveyService.setProjectManagerForAllSurveys(
        this.form.value[key] as ProjectManagers
      );
    }
  }

  private _patchSurvey(surveyId: number, payload: PatchSurveyInterface[]) {
    return this._buyerApiService
      .patchSurvey(surveyId, payload)
      .pipe(
        catchError((error) =>
          throwError(new SurveyUpdateError(error, this._auth.buyerConfig!))
        )
      )
      .toPromise()
      .catch((error) => this._toastr.error(error.message));
  }

  public updateScheduleaunchFlag(scheduleLaunchChange: boolean = false) {
    this.form.patchValue({
      schedule_launch: {
        enable: scheduleLaunchChange,
      },
    });

    this.softLaunchDisable = scheduleLaunchChange;
    this.softLaunchSlideDisable = scheduleLaunchChange;
    this.fieldOverTimeDisable = scheduleLaunchChange;
    this.updatePayload({
      schedule_launch: {
        enable: scheduleLaunchChange,
      },
    });
  }

  public updateLinkSecurity(linkSecurityChange: boolean = true) {
    this.notEditableBasicToken = true;
    const patchPayload = [
      {
        op: 'replace',
        path: '/basic_token',
        value: {
          enable: linkSecurityChange,
          value: this.form.value.basic_token.value,
        },
      },
    ];
    this._buyerApiService
      .patchSurvey(this.surveyId, patchPayload)
      .toPromise()
      .then(
        (response) => {
          this._toastr.success(notifyMessage.successMessage.BASIC_TOKEN_SAVED);
          const basicTokenValue = response.basic_token.value
            ? response.basic_token.value
            : '';
          this.form.patchValue({
            basic_token: {
              enable: response.basic_token.enable,
              value: basicTokenValue,
            },
          });
          this.fixedBasicTokenValue = basicTokenValue;
          this.updatePayload({
            basic_token: response.basic_token,
          });
        },
        (error) => {
          this._toastr.error(error.error.ps_api_response_message);
          if (this.form.value.basic_token.value.length > 0) {
            this.form.patchValue({
              basic_token: {
                enable: true,
                value: this.fixedBasicTokenValue,
              },
            });
          }
        }
      );
  }

  public downloadSampleUniqBuyerEntryLink() {
    window.open(this.buyerEntryLinkInfo[0].templatePath, '_blank');
  }

  public async uploadMappings(event: Event) {
    const target = event.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];
    const csvDataInJson: any = await this._csvToJson.csvToJson(file);
    this.buyerEntryLinksArr = csvDataInJson.map((i: Array<string>) => i[0]);
    // Removing the null or empty or duplicate URLs
    this.buyerEntryLinksArr = [
      ...new Set(this.buyerEntryLinksArr.filter(Boolean)),
    ];
    this.setBuyerLinkSliderValue();
    this.buyerEntryLinkUploaded = true;
    const testEntryLink = this.generateEntryLink('link');
    this.form.patchValue({
      test_ps_survey_entry_link: testEntryLink,
    });
    this.updatePayload({
      unique_links: {
        enable: this.form.value.uniqBuyerEntryLinkFlag,
        items: this.buyerEntryLinksArr,
      },
      test_ps_survey_entry_link: testEntryLink,
    });
    this._surveyMetaDataService.saveSurvey();
  }

  public clearUploadedBuyerEntryLinks() {
    const modalRef = this._modal.open(ConfirmationModalComponent, {
      width: '373px',
      data: {
        text: 'Are you sure you want to clear Buyer Entry Links?',
        confirmButtonLabel: 'Clear Buyer Entry Links',
      },
    });

    modalRef.onClose$.subscribe((msg) => {
      if (msg === 'ok') {
        this.buyerEntryLinksArr = [];
        this.buyerEntryLinkUploaded = false;
        const testEntryLink = '';
        this.form.patchValue({
          test_ps_survey_entry_link: testEntryLink,
        });
        this.isBuyerLinkSliderDisabled = false;
        this.updatePayload({
          unique_links: {
            enable: this.form.value.uniqBuyerEntryLinkFlag,
            items: this.buyerEntryLinksArr,
          },
          test_ps_survey_entry_link: testEntryLink,
        });
      }
    });
  }

  public viewBuyerLinks() {
    this._modal.open(BuyerEntryLinkViewModalComponent, {
      data: this.buyerEntryLinksArr,
      width: '80%',
      height: '80%',
    });
  }

  public launchquantityChange() {
    this.form.controls.launchpercentile.setValue(
      Math.round(
        (this.form.value.launchquantity * 100) /
          this.form.value.completes_required
      )
    );

    this.updatePayload({
      soft_launch: {
        enable: this.form.value.softLaunch,
        quantity: this.form.value.launchquantity,
      },
    });
  }

  public launchpercentileChange() {
    this.form.controls.launchquantity.setValue(
      Math.round(
        (this.form.value.launchpercentile *
          this.form.value.completes_required) /
          100
      )
    );

    this.updatePayload({
      soft_launch: {
        enable: this.form.value.softLaunch,
        quantity: this.form.value.launchquantity,
      },
    });
  }

  public updateSoftLaunch(softLaunchChange: boolean = false) {
    this.scheduleLaunchSlideDisable =
      this.surveyDatails.ps_survey_status !== SurveyStatus.Draft ||
      softLaunchChange;
    this.fieldOverTimeDisable = softLaunchChange;
    if (this.form.value.is_feot_enabled && softLaunchChange) {
      this._toastr.error(notifyMessage.errorMessage.SOFT_LAUNCH_ERROR_MESSAGE);
      this.form.controls.is_feot_enabled.setValue(false);
    }
    this.form.controls.softLaunch.setValue(!this.form.value.softLaunch);
    this.updatePayload({
      soft_launch: {
        enable: this.form.value.softLaunch,
        quantity: this.form.value.launchquantity,
      },
    });
  }

  public updateQuotaThrottling() {
    this.form.controls.quota_throttling.setValue(
      !this.form.value.quota_throttling
    );

    this.updatePayload({
      quota_throttling: this.form.value.quota_throttling,
    });
  }

  public showFeotFields(feotchange: boolean = false) {
    this.form.controls.is_feot_enabled.setValue(feotchange);
    this.scheduleLaunchSlideDisable =
      this.surveyDatails.ps_survey_status !== SurveyStatus.Draft || feotchange;
    this.softLaunchDisable = feotchange;
    this.softLaunchSlideDisable = feotchange;
    if (this.form.value.softLaunch && feotchange) {
      this._toastr.error(notifyMessage.errorMessage.SOFT_LAUNCH_ERROR_MESSAGE);
      this.form.controls.softLaunch.setValue(false);
    }
    this._calculateFeotFields();
    this.updatePayload({ is_feot_enabled: feotchange });
  }

  private _calculateFeotFields() {
    if (this.form.value.is_feot_enabled) {
      const totalClicksOrCompletes = this.isClickSurvey
        ? this.surveyPayload.estimated_clicks
        : this.form.value.completes_required;
      const remainingTime = this._calculateFeotRemainingTime();

      this.feotFields.feotQuantity =
        remainingTime <= 0
          ? Math.round(totalClicksOrCompletes / this.surveyPayload.field_time)
          : Math.round(totalClicksOrCompletes / remainingTime);
      this.feotFields.feotRemainingTime =
        remainingTime <= 0 ? 0 : remainingTime;
    } else {
      this.feotFields.feotQuantity = 200;
      this.feotFields.feotRemainingTime = 5;
    }
    this._eventEmitterService.sendFeotFieldCalculation(this.feotFields);
  }

  private _calculateFeotRemainingTime() {
    const { field_time: fieldTimeDays } = this.form.value;
    const { pacing, is_custom: isCustomPacing } = this.form.value.feot;
    let scopedPacing = isCustomPacing ? pacing : 'days';

    const fieldTimeWeeks = fieldTimeDays / 7;
    const fieldTimeHours = fieldTimeDays * 24;

    if (this.surveyDatails.ps_survey_status !== SURVEY_STATUS.LIVE) {
      switch (scopedPacing) {
        case 'weeks':
          return Math.ceil(fieldTimeWeeks);
        case 'days':
          return Math.ceil(fieldTimeDays);
        case 'hours':
          return Math.ceil(fieldTimeHours);
        default:
          return Math.ceil(fieldTimeDays);
      }
    }

    const timeElapsed = Date.now() - this.surveyDatails.launch_date;
    const timeElapsedHours = timeElapsed / 1000 / 60 / 60;
    const timeElapsedDays = timeElapsedHours / 24;
    const timeElapsedWeeks = timeElapsedDays / 7;
    console.log(
      'time elapsed h:',
      timeElapsedHours,
      'fieldtime h:',
      fieldTimeHours
    );

    switch (scopedPacing) {
      case 'weeks':
        return Math.ceil(fieldTimeWeeks - timeElapsedWeeks);
      case 'days':
        return Math.ceil(fieldTimeDays - timeElapsedDays);
      case 'hours':
        return Math.ceil(fieldTimeHours - timeElapsedHours);
      default:
        return Math.ceil(fieldTimeDays - timeElapsedDays);
    }
  }

  public openTab(url: string) {
    if (this.form.value.uniqBuyerEntryLinkFlag) {
      // If user attempts to test URL, but buyer entry links not uploaded
      if (!this.buyerEntryLinkUploaded) {
        return this._toastr.error(
          notifyMessage.errorMessage.ALL_FIELDS_REMAINING
        );
      }
    }
    if (!url) {
      return this._toastr.error(notifyMessage.errorMessage.URL_UPDATE);
    }
    // Testing URL in case of Unique buyer entry links - No patching of live URL required
    if (this.form.value.uniqBuyerEntryLinkFlag) {
      return window.open(url, '_blank');
    }
    // Testing URL in case of Live URL
    const payload = [
      {
        op: 'replace',
        path: `/live_url`,
        value: this.form.value.live_url,
      },
      {
        op: 'replace',
        path: `/test_url`,
        value:
          this.form.value.test_url !== '' && this.form.value.test_url !== null
            ? this.form.value.test_url
            : this.form.value.live_url,
      },
    ];
    this._patchSurvey(this.surveyId, payload).then(
      (response) => {
        window.open(url, '_blank');
      },
      (error) => {
        this._toastr.error(error.error.ps_api_response_message);
      }
    );
  }

  public setLiveUrlInfo(url: string) {
    if (
      !url &&
      this.finalizeInitialValues.live_url &&
      !this.form.get('live_url')?.dirty
    ) {
      url = this.finalizeInitialValues.live_url;
      this.form.patchValue(
        { live_url: this.finalizeInitialValues.live_url },
        { emitEvent: false }
      );
    }

    this._changeLiveUrlInfo(url);
    const testEntryLink = this.generateEntryLink(url);
    this.form.patchValue({
      test_ps_survey_entry_link: testEntryLink,
    });
    this.updatePayload({
      live_url:
        this.surveyPayload.unique_links &&
        this.surveyPayload.unique_links.enable
          ? ''
          : url,
      test_ps_survey_entry_link: testEntryLink,
    });
  }

  public generateEntryLink(url: string) {
    const fieldTime = this.form.value.field_time;
    let testLink = '';

    if (url && fieldTime) {
      testLink = `${this._baseUrl}/#/start-survey?survey_id=${this.surveyId}&ps_redirect_test=1&bsec=${GlobalConstants.BSEC}&supplier_id=${this._env.environment.BUYER_TEST_LINK_SUPPLIER_ID}`;
    }
    return testLink;
  }

  /**
   * @param {isURLTransform} : Flag to check variable mapping is disable or Not
   *  check live and test url variable mapping is disable or Not
   * */
  public checkDisableAutoMapping(disableUrlMapping: boolean) {
    if (disableUrlMapping) {
      this.warningTestFlg = false;
      this.warningFlg = false;
      this.testUrlCheck = false;
      this.liveUrlCheck = false;
      this.form.patchValue({
        liveUrlTT: this.form.value.live_url
          ? `Since you have disabled automatic variable mapping, no variables will be appended to your link.  Respondents will be redirected to: ${this.form.value.live_url}`
          : `Please enter your Survey URL to check its final form.`,
      });
      this.form.patchValue({
        testUrlTT: this.form.value.test_url
          ? `Since you have disabled automatic variable mapping, no variables will be appended to your link.  Respondents will be redirected to: ${this.form.value.test_url}`
          : `Your TEST URL is empty, we will use your LIVE URL as the TEST URL. Please add a TEST URL if it is different than the LIVE URL.`,
      });
    } else {
      this._getBuyerInfo(this.userDetails.cmp);
      this._changeLiveUrlInfo(this.form.value.live_url);
      this.changeTestUrlInfo(this.form.value.test_url);
    }

    this.updatePayload({ url_transform: disableUrlMapping });
  }

  private _getBuyerInfo(id: number) {
    const buyerSetting$ = this._buyerSettingsService
      .getBuyerSettings(id)
      .subscribe(
        (res) => {
          if (res.buyer.variable_mapping) {
            for (let i = 0; i < res.buyer.variable_mapping.length; i++) {
              for (let j in res.buyer.variable_mapping[i]) {
                if (j == 'ps_transaction') {
                  this.buyerSettings.ps_transaction =
                    res.buyer.variable_mapping[i][j].outgoing;
                }
                if (j == 'ps_psid') {
                  this.buyerSettings.ps_psid =
                    res.buyer.variable_mapping[i][j].outgoing;
                }
                if (j == 'ps_status') {
                  this.buyerSettings.ps_status =
                    res.buyer.variable_mapping[i][j].outgoing;
                }
                if (j == 'ps_hash') {
                  this.buyerSettings.ps_hash =
                    res.buyer.variable_mapping[i][j].outgoing;
                }
                if (j == 'ps_transaction_id2') {
                  this.buyerSettings.ps_transaction_id2 =
                    res.buyer.variable_mapping[i][j].outgoing;
                }
                if (j == 'ps_transaction_id3') {
                  this.buyerSettings.ps_transaction_id3 =
                    res.buyer.variable_mapping[i][j].outgoing;
                }
                if (j == 'ps_transaction_id4') {
                  this.buyerSettings.ps_transaction_id4 =
                    res.buyer.variable_mapping[i][j].outgoing;
                }
                if (j == 'ps_supplier_id') {
                  this.buyerSettings.ps_supplier_id =
                    res.buyer.variable_mapping[i][j].outgoing;
                }
              }
            }
          }

          this.checkWithUserUrl = this.buyerSettings.ps_transaction + '=';
          this._addUrlTT();
        },
        (err) => {
          const errorMessage = err.error.msg;
          this._toastr.error(errorMessage);
        }
      );
    this._subscriptions.add(buyerSetting$);
  }

  private _addUrlTT() {
    if (this._validateUrl(this.form.value.live_url)) {
      const operationalBuyerUrl = this._getOperationalBuyerUrl(
        this.form.value.live_url,
        this.buyerSettings,
        0
      );
      this.form.patchValue({
        liveUrlTT: `Your URL settings transform the Entry URL into: \n\n ${operationalBuyerUrl}`,
      });
    } else {
      this.form.patchValue({
        liveUrlTT: 'Please enter your Survey URL to check its final form.',
      });
      this.form.value.liveUrlTT =
        'Please enter your Survey URL to check its final form.';
    }
    if (this._validateUrl(this.form.value.test_url)) {
      const operationalBuyerUrl = this._getOperationalBuyerUrl(
        this.form.value.test_url,
        this.buyerSettings,
        1
      );
      this.form.patchValue({
        testUrlTT: `Your URL settings transform the Entry URL into: \n\n ${operationalBuyerUrl}`,
      });
    } else {
      this.form.patchValue({
        testUrlTT: `Your TEST URL is empty, we will use your LIVE URL as the TEST URL. Please add a TEST URL if it is different than the LIVE URL.`,
      });
    }
  }

  private _getOperationalBuyerUrl(
    url: string,
    buyerSettings: any,
    isTest: any
  ) {
    if (
      this._operationalBuyerUrlValidation(this.buyerSettings.ps_transaction)
    ) {
      url = this._getQueryStringUrl(url);
      url += `${this.buyerSettings.ps_transaction}=[%%ps_transaction_id%%]`;
    } else {
      url = this._getQueryStringUrl(url);
      url += 'transaction_id=[%%ps_transaction_id%%]';
    }
    if (this._operationalBuyerUrlValidation(this.buyerSettings.ps_psid)) {
      url = this._getQueryStringUrl(url);
      url += `${this.buyerSettings.ps_psid}=[%%psid%%]`;
    }

    if (this._operationalBuyerUrlValidation(this.buyerSettings.ps_status)) {
      url = this._getQueryStringUrl(url);
      url += this.buyerSettings.ps_status + '=[%%st%%]';
    }

    if (
      this._operationalBuyerUrlValidation(this.buyerSettings.ps_transaction_id2)
    ) {
      url = this._getQueryStringUrl(url);
      url += `${this.buyerSettings.ps_transaction_id2}=[%%ps_transaction_id%%]`;
    }

    if (
      this._operationalBuyerUrlValidation(this.buyerSettings.ps_transaction_id3)
    ) {
      url = this._getQueryStringUrl(url);
      url += this.buyerSettings.ps_transaction_id3 + '=[%%ps_transaction_id%%]';
    }
    if (
      this._operationalBuyerUrlValidation(this.buyerSettings.ps_transaction_id4)
    ) {
      url = this._getQueryStringUrl(url);
      url += `${this.buyerSettings.ps_transaction_id4}=[%%ps_transaction_id%%]`;
    }
    if (
      this._operationalBuyerUrlValidation(this.buyerSettings.ps_supplier_id)
    ) {
      url = this._getQueryStringUrl(url);
      url += `${this.buyerSettings.ps_supplier_id}=[%%ps_supplier_id%%]`;
    }

    return url;
  }

  private _operationalBuyerUrlValidation(id: string) {
    return typeof id !== 'undefined' && id !== '' ? true : false;
  }

  private _getQueryStringUrl(url: any) {
    if (url != '' && url != undefined && url != null) {
      if (url.search(/^http[s]?\:\//) == -1) {
        url = 'http://' + url;
      }
      let re = /[?]/;
      let result = url.match(re);
      if (result && result[0] == '?') {
        let lastChar = url.charAt(url.length - 1);
        if (lastChar != '&') {
          url = url + '&';
        }
        return url;
      } else {
        url = url + '?';
        return url;
      }
    }
  }

  /**
   * @param {newValue}: Current value of the testUrl
   * It is used when value is change of test url or the change of isURLTransform flag
   */
  private _changeLiveUrlInfo(newValue: string) {
    this.warningFlg = false;
    this.showTransIdWarningMsg = false;
    this.showNonHttpsWarningMsg = false;
    let trans_id;
    // url_transform is unchecked then will show the warnings and variable mapping messages
    if (!this.form.value.url_transform) {
      //Do anything with live_url
      if (this._validateNewValue(newValue)) {
        this.form.patchValue({
          liveUrlTT: 'Please enter your Survey URL to check its final form.',
        });
      } else {
        let operationalBuyerUrl = this._getOperationalBuyerUrl(
          newValue,
          this.buyerSettings,
          0
        );
        this.form.patchValue({
          liveUrlTT: `Your URL settings transform the Entry URL into: \n\n ${operationalBuyerUrl}`,
        });
      }
      if (this._validateUrl(this.form.value.live_url)) {
        if (this.form.value.live_url.search(this.regexAmprsnd) != -1) {
          this.warningFlg = true;
          this.showTransIdWarningMsg = true;
          let splitUrl = this.form.value.live_url.split('transaction_id=');
          if (splitUrl[1]) {
            trans_id = `&transaction_id=${splitUrl[1]}`;
          } else {
            trans_id = '&transaction_id=';
          }
        } else {
          if (this.form.value.live_url.search(this.regexQustionMrk) != -1) {
            this.warningFlg = true;
            this.showTransIdWarningMsg = true;
            let splitUrl = this.form.value.live_url.split('transaction_id=');
            if (splitUrl[1]) {
              trans_id = `&transaction_id=${splitUrl[1]}`;
            } else {
              trans_id = '&transaction_id=';
            }
          }
        }
        this.form.patchValue({
          liveWarningMsg: `We think there's an issue with your URL. Please remove the portion that reads ${trans_id} \n\n.\n\nIf you are certain that your link is okay as is, please continue.`,
        });

        this.liveUrlCheck =
          this.form.value.live_url.endsWith('=') ||
          this.form.value.live_url.indexOf('' + this.checkWithUserUrl + '') !==
            -1;
      }
    } else {
      this.form.patchValue({
        liveUrlTT: this.form.value.live_url
          ? `Since you have disabled automatic variable mapping, no variables will be appended to your link.  Respondents will be redirected to: ${this.form.value.live_url}`
          : `Please enter your Survey URL to check its final form.`,
      });
    }
    const regExNonHttpsUrl = new RegExp('http://', 'g');
    if (
      this.form.value.live_url &&
      this.form.value.live_url.search(regExNonHttpsUrl) != -1
    ) {
      this.warningFlg = true;
      this.showNonHttpsWarningMsg = true;
      this.form.patchValue({
        nonHttpsWarningMsg:
          'Please use "https://" instead of "http://" if possible.',
      });
    }
  }

  private _validateNewValue(newValue: string) {
    return typeof newValue === 'undefined' ||
      newValue === '' ||
      newValue === 'null'
      ? true
      : false;
  }

  private _validateUrl(url: string) {
    return url != undefined && url != null && url != '' ? true : false;
  }

  private updateTestUrl(newValue: string) {
    if (
      !newValue &&
      this.finalizeInitialValues.test_url &&
      !this.form.get('test_url')?.dirty
    ) {
      newValue = this.finalizeInitialValues.test_url;
      this.form.patchValue(
        { test_url: this.finalizeInitialValues.test_url },
        { emitEvent: false }
      );
    }
    return newValue;
  }

  public changeTestUrlInfo(newValue: string) {
    this.warningTestFlg = false;
    let trans_id;
    newValue = this.updateTestUrl(newValue);
    // url_transform is unchecked then will show the warnings and variable mapping messages
    if (!this.form.value.url_transform) {
      //Do anything with test_url
      if (this._validateNewValue(newValue)) {
        this.form.patchValue({
          testUrlTT:
            'Your TEST URL is empty, we will use your LIVE URL as the TEST URL. Please add a TEST URL if it is different than the LIVE URL.',
        });
      } else {
        const operationalBuyerUrl = this._getOperationalBuyerUrl(
          newValue,
          this.buyerSettings,
          1
        );
        this.form.patchValue({
          testUrlTT: `Your URL settings transform the Entry URL into: \n\n ${operationalBuyerUrl}`,
        });
      }
      if (this._validateUrl(this.form.value.test_url)) {
        if (this.form.value.test_url.search(this.regexAmprsnd) != -1) {
          this.warningTestFlg = true;
          let splitUrl = this.form.value.test_url.split('transaction_id=');
          if (splitUrl[1]) {
            trans_id = `&transaction_id=${splitUrl[1]}`;
          } else {
            trans_id = '&transaction_id=';
          }
        } else {
          if (this.form.value.test_url.search(this.regexQustionMrk) != -1) {
            this.warningTestFlg = true;
            let splitUrl = this.form.value.test_url.split('transaction_id=');
            if (splitUrl[1]) {
              trans_id = `&transaction_id=${splitUrl[1]}`;
            } else {
              trans_id = '&transaction_id=';
            }
          }
        }

        this.form.patchValue({
          testWarningMsg: `We think there's an issue with your URL. Please remove the portion that reads ${trans_id} \n\n.\n\nIf you are certain that your link is okay as is, please continue.`,
        });
        this.testUrlCheck =
          this.form.value.test_url.endsWith('=') ||
          this.form.value.test_url.indexOf('' + this.checkWithUserUrl + '') !==
            -1;
      }
    } else {
      this.form.patchValue({
        testUrlTT: this.form.value.test_url
          ? `Since you have disabled automatic variable mapping, no variables will be appended to your link.  Respondents will be redirected to: ${this.form.value.test_url}`
          : `Your TEST URL is empty, we will use your LIVE URL as the TEST URL. Please add a TEST URL if it is different than the LIVE URL.`,
      });
    }

    this.updatePayload({ test_url: newValue });
  }

  public _updateScheduleLaunchInformation(surveyPayload: SurveyPayload) {
    const scheduleInfo = surveyPayload.schedule_launch?.info ?? {};

    const momentApiCaller = (momentLib: any, ...props: unknown[]) =>
      'default' in momentLib
        ? momentLib.default(...props)
        : momentLib(...props);
    const date = momentApiCaller(
      moment,
      scheduleInfo.dateTimeInISO ?? Date.now()
    )
      .tz(scheduleInfo.timezone ?? moment.tz.guess())
      .format('YYYY-MM-DD');

    this.form.patchValue({
      scheduledLaunchDetails: {
        date: date,
        hours: this._formatTimeToPresentation(scheduleInfo.hours ?? undefined),
        minutes: this._formatTimeToPresentation(
          scheduleInfo.minutes ?? undefined
        ),
        timezone: scheduleInfo.timezone ?? undefined,
      },
    });

    this.updatePayload({
      schedule_launch: this._mapScheduleLaunchPayload(),
    });
  }

  public selectScheduledLaunchDate(value: SelectDate) {
    this.form.patchValue({
      scheduledLaunchDetails: {
        date: this._datepipe.transform(value.start._d, 'yyyy-MM-dd'),
      },
    });

    this.updatePayload({
      schedule_launch: this._mapScheduleLaunchPayload(),
    });
  }

  private _formatTimeToPresentation(
    value: number | undefined
  ): string | undefined {
    if (value == undefined || value == null) {
      return;
    }

    return value < 10 ? `0${value}` : value.toString();
  }

  public datapickerOptions = {
    locale: { format: 'YYYY-MM-DD' },
    singleDatePicker: true,
    alwaysShowCalendars: false,
    minDate: new Date(),
  };

  private _createDateRangePickerOption() {
    this.filterByDatapickerOptions = {
      locale: { format: 'YYYY-MM-DD' },
      alwaysShowCalendars: false,
      showDropdowns: true,
    };
  }

  private _assignTimeField() {
    //get hours
    for (let i = 0; i < 24; i++) {
      this.hours.push({ key: i < 10 ? `0${i}` : i.toString() });
    }

    //get minutes
    for (let i = 0; i < 60; i++) {
      this.minutes.push({ key: i < 10 ? `0${i}` : i.toString() });
    }

    //get timezone
    for (let i = 0; i < moment.tz.names().length; i++) {
      let tzObj = {
        index: i,
        name:
          ' (GMT' +
          moment.tz(moment.tz.names()[i]).format('Z') +
          ') ' +
          moment.tz.names()[i],
        value: moment.tz.names()[i],
      };
      this.tzNames.push(tzObj);
    }
  }

  public selectTimeZone(timezone: TimeZone) {
    this.form.patchValue({
      scheduledLaunchDetails: {
        timezone: timezone.value,
      },
    });
    this.updatePayload({
      schedule_launch: this._mapScheduleLaunchPayload(),
    });
  }

  public selectHours(value: SelectTime) {
    this.form.patchValue({
      scheduledLaunchDetails: {
        hours: value.key,
      },
    });
    this.updatePayload({
      schedule_launch: this._mapScheduleLaunchPayload(),
    });
  }

  public selectMinutes(value: SelectTime) {
    this.form.patchValue({
      scheduledLaunchDetails: {
        minutes: value.key,
      },
    });
    this.updatePayload({
      schedule_launch: this._mapScheduleLaunchPayload(),
    });
  }

  private _createQbpSelectionQuotas(quotas: Quotas[]) {
    if (quotas.length) {
      // Group quotas by category(eg: autoNested, layered)
      const groupedQuota = quotas.reduce((acc: any, quota: Quotas) => {
        const key = quota['quota_category'];
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(quota);
        return acc;
      }, {});
      const layeredAndGroupedQuotas = [
        ...(groupedQuota.layered || []),
        ...(groupedQuota.grouped || []),
      ];
      this._prepareQbpLayeredAndGroupedQuotas(layeredAndGroupedQuotas);
      this._prepareQbpAdvanceQuotas(groupedQuota.advance);
      // Sorting quotas to show in the QBP list
      this.qbpSelectionQuotas.sort((a, b) => a.name.localeCompare(b.name));
      this._prepareQbpNestedQuotas(groupedQuota.autoNested);
      this._patchSelectedQuota();
      this._setQbpSelectionDetails(this.form.value.qbp);
    }
  }

  private _prepareQbpLayeredAndGroupedQuotas(layeredQuotas: Quotas[] = []) {
    const layeredQuotasByQualification = layeredQuotas.reduce(
      (acc: any, quota: Quotas) => {
        const key =
          quota.criteria.length === 1 && quota.group_key !== 'Children'
            ? quota.criteria[0].qualification_name
            : 'children';
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(quota);
        return acc;
      },
      {}
    );

    if (
      layeredQuotasByQualification &&
      Object.keys(layeredQuotasByQualification).length
    ) {
      for (const qualName in layeredQuotasByQualification) {
        let tempObj = <QbpSelectionQuota>{};
        tempObj.name = tempObj.category = this._capitalizeFirstLetter(
          qualName.replace(/ /g, '')
        );
        tempObj.selectedQuotaIds = layeredQuotasByQualification[qualName].map(
          (quota: Quotas) => quota['buyer_quota_id']
        );
        this.qbpSelectionQuotas.push(tempObj);
      }
    }
  }

  private _prepareQbpAdvanceQuotas(advanceQuotas: Quotas[] = []) {
    const advanceQuotasGroupByQualName = advanceQuotas.reduce(
      (acc: any, advanceQuota: Quotas) => {
        const key = advanceQuota.criteria[0].qualification_name;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(advanceQuota);
        return acc;
      },
      {}
    );

    if (
      advanceQuotasGroupByQualName &&
      Object.keys(advanceQuotasGroupByQualName).length
    ) {
      for (const qualName in advanceQuotasGroupByQualName) {
        let tempObj = <QbpSelectionQuota>{};
        tempObj.name = tempObj.category = this._capitalizeFirstLetter(
          qualName.toLowerCase().replace(/ /g, '_')
        );
        tempObj.selectedQuotaIds = advanceQuotasGroupByQualName[qualName].map(
          (quota: Quotas) => quota['buyer_quota_id']
        );
        this.qbpSelectionQuotas.push(tempObj);
      }
    }
  }

  private _prepareQbpNestedQuotas(nestedQuotas: Quotas[] = []) {
    if (nestedQuotas && nestedQuotas.length) {
      let tempObj = <QbpSelectionQuota>{};
      tempObj.category = 'autoNested';
      let qualNames = nestedQuotas[0].criteria.map(
        (criteria: Criteria) => criteria['qualification_name']
      );
      qualNames = qualNames.map((qualName: string) => {
        return this._capitalizeFirstLetter(qualName.replace(/ /g, ''));
      });
      tempObj.name = `Nested - ${qualNames.toString()}`;
      tempObj.selectedQuotaIds = nestedQuotas.map(
        (quota: Quotas) => quota['buyer_quota_id']
      );
      this.qbpSelectionQuotas.unshift(tempObj);
    }
  }

  private _patchSelectedQuota() {
    this.form.controls.qbpSelectedQuota.setValue(this.qbpSelectionQuotas[0]);
    this.updatePayload({
      qbp: {
        enable: this.form.value.qbp.enable,
        quota_ids: this.form.value.qbpSelectedQuota.selectedQuotaIds || [],
      },
    });
  }

  private _capitalizeFirstLetter(s: string) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  private _setQbpSelectionDetails(qbp: Qbp) {
    if (qbp.category && qbp.selectedQuotaIds && qbp.selectedQuotaIds.length) {
      const defaultSelection = this.qbpSelectionQuotas.find(
        (i: QbpSelectionQuota) => {
          if (
            i.category.toLowerCase().trim().replace(/_/g, '') ===
            'householdincome'
          ) {
            return i.category
              .toLowerCase()
              .trim()
              .replace(/_/g, '')
              .includes(qbp.category.toLowerCase().trim().replace(/_/g, ''));
          }
          return (
            i.category.toLowerCase().trim().replace(/_/g, '') ===
            qbp.category.toLowerCase().trim().replace(/_/g, '')
          );
        }
      );
      if (defaultSelection) {
        this.form.patchValue({
          qbpSelectedQuota: defaultSelection,
        });
        this.updatePayload({
          qbp: {
            enable: this.form.value.qbp.enable,
            quota_ids: this.form.value.qbpSelectedQuota.selectedQuotaIds || [],
          },
        });
      } else {
        this._setActiveQuotaSelectionQbp();
      }
    }

    if (
      this.form.value.qbpSelectedQuota &&
      !Object.keys(this.form.value.qbpSelectedQuota).length
    ) {
      this.form.patchValue({
        qbpSelectedQuota: {
          category: qbp.category ? qbp.category : '',
          selectedQuotaIds: [],
        },
      });
      this.updatePayload({
        qbp: {
          enable: this.form.value.qbp.enable,
          quota_ids: this.form.value.qbpSelectedQuota.selectedQuotaIds || [],
        },
      });
    }
    if (!this.qbpSelectedQuotaCategory && this.form.value.qbpSelectedQuota) {
      this.qbpSelectedQuotaCategory = this.form.value.qbpSelectedQuota.category;
    }
  }

  private _setActiveQuotaSelectionQbp() {
    let nestedQuotaIndex = 0;
    if (this.qbpSelectedQuotaCategory) {
      nestedQuotaIndex = this.qbpSelectionQuotas.findIndex(
        (e: QbpSelectionQuota) => e.category == this.qbpSelectedQuotaCategory
      );
    } else {
      nestedQuotaIndex = this.qbpSelectionQuotas.findIndex(
        (e: QbpSelectionQuota) => e.category == 'autoNested'
      );
    }
    if (nestedQuotaIndex >= 0) {
      this.form.patchValue({
        qbpSelectedQuota: this.qbpSelectionQuotas[nestedQuotaIndex],
      });
    } else {
      this.form.patchValue({
        qbpSelectedQuota: this.qbpSelectionQuotas[0],
      });
    }
    this.updatePayload({
      qbp: {
        enable: this.form.value.qbp.enable,
        quota_ids: this.form.value.qbpSelectedQuota.selectedQuotaIds || [],
      },
    });
  }

  public updateQBPToggle() {
    if (this.qbpSelectionQuotas.length) {
      this.form.patchValue({
        qbp: {
          enable: !this.form.value.qbp.enable,
        },
      });
      this.updatePayload({
        qbp: {
          enable: this.form.value.qbp.enable,
          quota_ids: this.form.value.qbpSelectedQuota.selectedQuotaIds || [],
        },
      });
    } else {
      let qbpValidationText =
        'To enable QUOTA-BASED PRICING you need to have set quotas on your project.';
      if (!this.isInsight) {
        qbpValidationText +=
          " Please use the bottom navigation to go back to the 'Define Audience'section and build your audience quotas.";
      }
      const modalRef = this._modal.open(ConfirmationModalComponent, {
        data: {
          text: qbpValidationText,
        },
        maxWidth: '450px',
      });

      modalRef.onClose$.subscribe((msg) => {
        this.form.patchValue({
          qbp: {
            enable: false,
          },
        });
        this.updatePayload({
          qbp: {
            enable: this.form.value.qbp.enable,
            quota_ids: this.form.value.qbpSelectedQuota?.selectedQuotaIds || [],
          },
        });
      });
    }
  }

  public updateQLCToggle() {
    if (
      this.surveyDatails &&
      this.surveyDatails.quotas &&
      this.surveyDatails.quotas.length
    ) {
      this.form.patchValue({
        qlc: {
          enable: !this.form.value.qlc.enable,
        },
      });
      this.updatePayload({
        qlc: {
          enable: this.form.value.qlc.enable,
          multiple_quotas: {
            enable: false,
            count_by_quota: false,
            compensate_by_quota: false,
          },
        },
      });
    } else {
      const modalRef = this._modal.open(ConfirmationModalComponent, {
        data: {
          text: "To enable QUOTA-LEVEL COMPLETE tracking you need to have set quotas on your project. Please use the bottom navigation to go back to the 'Define Audience' section and build your audience quotas.",
        },
        maxWidth: '450px',
      });

      modalRef.onClose$.subscribe((msg) => {
        this.form.patchValue({
          qlc: {
            enable: false,
          },
        });
        this.updatePayload({
          qlc: {
            enable: this.form.value.qlc.enable,
            multiple_quotas: {
              enable: false,
              count_by_quota: false,
              compensate_by_quota: false,
            },
          },
        });
      });
    }
  }

  public setQbpSelection(quota: QbpSelectionQuota) {
    this.form.patchValue({
      qbpSelectedQuota: quota,
    });

    this.updatePayload({
      qbp: {
        enable: this.form.value.qbp.enable,
        quota_ids: this.form.value.qbpSelectedQuota.selectedQuotaIds || [],
      },
    });
  }

  private _manageLaunchEnableDisable(surveyDetail: BuyerSurveyResponse) {
    this.fieldOverTimeDisable = surveyDetail.soft_launch.enable;
    if (
      surveyDetail.ps_survey_status != SURVEY_STATUS.DRAFT ||
      surveyDetail.is_feot_enabled
    ) {
      this.scheduleLaunchSlideDisable = true;
    }
    this._scheduleLaunchDisableCheck(surveyDetail);
    if (
      surveyDetail.schedule_launch.enable &&
      surveyDetail.ps_survey_status === SURVEY_STATUS.DRAFT &&
      surveyDetail.scheduledLaunchDetails &&
      surveyDetail.scheduledLaunchDetails.timezone
    ) {
      this.softLaunchDisable = true;
    }
    if (this.softLaunchDisable || surveyDetail.is_feot_enabled) {
      this.softLaunchSlideDisable = true;
    }
    if (surveyDetail.ps_survey_status !== SURVEY_STATUS.DRAFT) {
      this.isQbpSliderDisabled = true;
      this.isQlcSliderDisabled = true;
    }
    if (this.surveyDatails.price_reco) {
      this.isQbpSliderDisabled = true;
    }
    this.form.value.qbp.enable =
      this.surveyDatails.price_reco || this.surveyDatails.is_qbp_enable;
  }

  private _scheduleLaunchDisableCheck(surveyDetail: BuyerSurveyResponse) {
    if (
      surveyDetail.ps_survey_status != SURVEY_STATUS.DRAFT ||
      (surveyDetail.schedule_launch.enable && surveyDetail.end_date)
    ) {
      this.scheduleLaunchDisable = true;
    }
  }

  public updatePayload(payload: any | null = null) {
    if (payload) {
      if (this._initDone) {
        this._surveyMetaDataService.setIsFormDirty(true);
      }
      this.surveyPayload = Object.assign(this.surveyPayload, payload);
    }
  }

  private _mapScheduleLaunchPayload() {
    if (!this.form.value.schedule_launch.enable) {
      return {
        enable: false,
      };
    }

    return {
      enable: true,
      info: {
        date: this.form.value.scheduledLaunchDetails.date || undefined,
        hours:
          Number(this.form.value.scheduledLaunchDetails.hours) || undefined,
        minutes:
          Number(this.form.value.scheduledLaunchDetails.minutes) ?? undefined,
        timezone: this.form.value.scheduledLaunchDetails.timezone || undefined,
      },
    };
  }

  public changeInclExcl(flagValue: number) {
    this.inclExclDisable = !!flagValue;
    if (this.enableFilteringByDate) {
      this.filterDateRange = {};
      this._setCurrentDateRangePicker();
      // If PSIDs are upload by survey grouping, then emptying them
      if (this.surveyGroupingPSIDUpload) {
        this._psids = [];
      }
      this.surveyGroupingPSIDUpload = false;
      this.form.patchValue({ incl_excl: flagValue, survey_grouping: [] });
      this.updatePayload({ incl_excl: flagValue, survey_grouping: [] });
      this._updateSurveyData();
    } else {
      this._setInclExcl(flagValue);
    }
  }

  private _setInclExcl(incl_excl: number) {
    this.inclExclDisable = !!incl_excl;
    this.form.patchValue({ incl_excl });
    this.updatePayload({ incl_excl });
  }

  public changeSurveyDQEnabled(flag: boolean) {
    this.form.patchValue({
      is_dq_enable: flag,
    });
    this.updatePayload({
      is_dq_enable: flag,
    });
  }

  public clearPSID() {
    const modalRef = this._modal.open(ConfirmationModalComponent, {
      data: {
        text: 'Are you sure you want to clear PSIDs?',
        cancelButtonLabel: 'Cancel',
        confirmButtonLabel: 'Clear PSIDs',
      },
      maxWidth: '400px',
      width: '373px',
    });
    modalRef.onClose$.subscribe((msg) => {
      if (msg == 'ok') {
        this._buyerApiService
          .clearUploadedPSIDs(this.surveyId)
          .subscribe((resp: ClearPsidsResponse) => {
            this._toastr.success('Sucess! PSIDs have been cleared');
            this.updatePayload({
              ref_list: [],
              hasPSIDRefList: false,
            });
            this.form.patchValue({ ref_list: [], hasPSIDRefList: false });
            this.inclExclBuyerUpload = false;
            this._sharedDataService.setPsidModelClose(false);
          });
      }
      if (msg == 'cancel') {
        this._sharedDataService.setPsidModelClose(true);
      }
    });
  }

  public viewPSID() {
    const modalRef = this._modal.open(ClearOrViewPsidModalComponent, {
      data: {
        psids: this._psids,
        isClearRequest: false,
      },
      height: '80%',
      width: '80%',
    });
  }

  public viewIncludePSID() {
    this._modal.open(IncludeListComponent, {
      data: {
        psids: this._includePsids,
      },
      height: '80%',
      width: '80%',
    });
  }

  public onFileChange(event: Event) {
    const element = <HTMLInputElement>event.currentTarget;
    this.file = (element.files as FileList)[0];
    if (element.files !== null) {
      this.fileName = this.file?.name;
      const fileExtension = this.fileName?.split('.').pop();
      if (element.files.length == 0) {
        this._toastr.warning(notifyMessage.warningMessage.NO_FILE);
        return;
      }
      if (this._validateFileExtention(this.file)) {
        this._uploadPsidList(this.file, event);
      }
    }
  }

  private _uploadPsidList(file: File, event: Event) {
    this._fdata = new FormData(); // clear _fdata
    this._fdata.append('psid_ref_file', file);

    this._buyerApiService
      .uploadPSIDRefFile(this.surveyId, this._fdata)
      .subscribe(
        (_res: PsidsUploadRefListResponse) => {
          this._toastr.success(notifyMessage.successMessage.FILE_ADDED);
          this.inclExclBuyerUpload = true;
          this.form.patchValue({
            hasPSIDRefList: true,
          });
          this._isQbpQualified();
          event.preventDefault();

          this._buyerApiService
            .getBuyerUploadedList(this.surveyId, this.surveyDatails.incl_excl)
            .subscribe((psidsResp: PsidsBuyerUploadListResponse) => {
              if (psidsResp && psidsResp.psids && psidsResp.psids.length) {
                this._psids = psidsResp.psids;
                this._updateSurveyPayloadWithPsids();
              }
            });
        },
        (err) => {
          const errorMessage = err.error.msg;
          if (errorMessage) {
            this._toastr.error(errorMessage);
          } else {
            this._toastr.error('Sorry, we had an unexpected error');
          }
        }
      );
  }

  private _updateSurveyPayloadWithPsids() {
    this._includePsids = this._psids.map((resp) => resp.PSID);
    const updatePayload = {
      ref_list: this._psids.map((resp) => {
        return { psid: resp.PSID };
      }),
    } as SurveyPayload;
    this._surveyMetaDataService.sendSurveyPayload(updatePayload);
  }

  private _isQbpQualified() {
    if (
      this.manageEdit &&
      this.surveyDatails.is_qbp_enable &&
      this.form.value.uniqBuyerEntryLinkFlag
    ) {
      this.form.patchValue({
        uniqBuyerEntryLinkFlag: false,
      });
    }
    if (
      this.surveyDatails.is_qbp_enable &&
      (this.surveyDatails.incl_excl || this.form.value.uniqBuyerEntryLinkFlag)
    ) {
      this.form.patchValue({
        is_qbp_enable: false,
      });
    }
  }

  private _validateFileExtention(file: File) {
    const validExt = new Array('.xls', '.xlsx', '.csv');
    if (!file) {
      this._toastr.error(notifyMessage.errorMessage.FILE_UPLOAD_MISSING);
      return false;
    }
    const fileExt = file.name.substring(file.name.lastIndexOf('.'));
    if (validExt.indexOf(fileExt) < 0) {
      this._toastr.error(
        notifyMessage.errorMessage.FILE_UPLOAD_ASK_EXTERNAL_BUYER
      );
      return false;
    }
    return true;
  }

  public setSurveyGrouping() {
    const surveyIds = this._getSurveysIdsFromForm();
    this._performActionsOnSurveyGroupingChange(surveyIds);
    if (this.enableFilteringByDate) {
      this._clearFilterByDateRange();
    }
    this._updateSurveyData();
  }

  private _getSurveysIdsFromForm() {
    let surveyIds: number[] = [];
    if (Array.isArray(this.form.value.survey_grouping)) {
      surveyIds = this.form.value.survey_grouping;
    } else {
      surveyIds = (this.form.value.survey_grouping || '')
        .split(',')
        .map((id: string) => +id)
        .filter(Number);
    }
    return surveyIds;
  }

  private _performActionsOnSurveyGroupingChange(surveyIds: number[]) {
    this.updatePayload({
      survey_grouping: surveyIds,
    });
    const payload = {
      surveyIds,
    };
    this._getIncludePsids(payload);
  }

  public setSubscriberEmails() {
    if (Array.isArray(this.form.value.subscriber_emails)) {
      this.updatePayload({
        subscriber_emails: this.form.value.subscriber_emails,
      });
    } else {
      this.updatePayload({
        subscriber_emails: this.form.value.subscriber_emails.split(','),
      });
    }
  }
  public _getGroupSurveyIds(
    startDate: string,
    endDate: string,
    locale: LocaleLanguageCountry
  ) {
    this._buyerApiService
      .getGroupSurveys(startDate.toString(), endDate.toString(), locale)
      .subscribe(
        (response) => {
          if (response) {
            const surveyIds: Array<number> = [];
            surveyIds.push(...response.map((resp) => Number(resp.id)));
            this.form.patchValue({
              survey_grouping: surveyIds,
            });
            this.includePostPayload = {
              fromDate: startDate.toString(),
              toDate: endDate.toString(),
              surveyIds: surveyIds,
            };
            this._getIncludePsids(this.includePostPayload);
            this._updateSurveyData();
          }
        },
        (error: any) => {
          this._toastr.error(error.error.msg);
        }
      );
  }

  public applyFilterDateRange(value: FilterDateRange) {
    this.filterDateRange.start = new Date(value.picker.startDate._d);
    this.filterDateRange.end = new Date(value.picker.endDate._d);
    const { start, end } = this._getStartEndDate();
    if (
      this.form.value.survey_grouping &&
      this.form.value.survey_grouping.length
    ) {
      this._toastr.warning(
        notifyMessage.warningMessage.EXCLUSION.CHANGING_DATE
      );
    }
    this._getGroupSurveyIds(String(start), String(end), this._locale);
  }

  public cancelFilterDateRange() {
    this.form.patchValue({
      survey_grouping: [...new Set(this.surveyDatails.survey_grouping)],
    });
    this._includePsids = [];
    this.filterDateRange = {};
    this._setCurrentDateRangePicker();
    this._updateSurveyData();
  }

  private _verifyCompanySettings(companyId: number) {
    this._buyerConfigService
      .getBuyerConfig()
      .subscribe((buyerConfigResponse: GetBuyerConfigResponse) => {
        this.isEnableMarginMaxForBuyer =
          !!buyerConfigResponse?.data?.enableMarginMax?.includes(companyId);
        this.isEnableBillingNumberRulesForBuyer =
          !!buyerConfigResponse?.data?.enableBillingNumberRules?.includes(
            companyId
          );
        this.enableMandatoryBillingNumber =
          !!buyerConfigResponse?.data?.enableMandatoryBillingNumber?.includes(
            companyId
          );

        this._surveyCompanySubject.next(companyId);
        this._setBillingNumberRules();
      });
  }

  private _updateSurveyData() {
    const { start = '', end = '' } = this._getStartEndDate();
    let updatePayload = {
      ref_list: this._includePsids.map((psid) => {
        return { psid };
      }),
      feasibility_exclusions: {
        enable: false,
        start,
        end,
        criterias: this.surveyDatails.feasibility_exclusions?.criterias,
      },
      survey_grouping: this._getSurveysIdsFromForm(),
    } as SurveyPayload;
    this._surveyMetaDataService.sendSurveyPayload(updatePayload);
  }

  private _getStartEndDate() {
    let { start = '', end = '' } = this.filterDateRange;
    if (start && end) {
      start = this._commonService.formatDate(start as Date);
      end = this._commonService.formatDate(end as Date);
    }
    return { start, end };
  }

  private _getIncludePsids(payload: IncludePostPayload) {
    if (!this.inclExclDisable) {
      return;
    }
    if (!this._validatePayload(payload)) {
      return;
    }
    this._buyerApiService
      .getIncludePsids(payload)
      .pipe(filter((psidsResponse) => !!psidsResponse))
      .subscribe(
        (psidsResponse: IncludePsidApiResponse) => {
          this._includePsids = psidsResponse.ref_list || [];
          this.surveyGroupingPSIDUpload = true;
          this.form.patchValue({
            survey_grouping: psidsResponse.survey_ids || [],
          });
          this._updateSurveyData();
          if (!this._includePsids?.length) {
            this._toastr.error(notifyMessage.errorMessage.NO_PSIDS_FOUND);
          }
        },
        (err) => {
          this._toastr.error(err.error.ps_api_response_message);
        }
      );
  }

  public updateMarginMax(isEnableMarginMax: boolean) {
    this.form.patchValue({
      is_enable_margin_max: isEnableMarginMax,
    });
    this.updatePayload({
      is_enable_margin_max: isEnableMarginMax,
    });
  }

  public updateFeotCustomPacing(isCustomPacingEnabled: boolean) {
    this.form.patchValue({
      feot: {
        is_custom: isCustomPacingEnabled,
      },
    });

    this.updatePayload({
      feot: {
        ...this.form.value.feot,
        is_custom: isCustomPacingEnabled,
      },
    });
    this._calculateFeotFields();
  }

  get isCustomPacingText(): Boolean {
    return this.form.value.feot.is_custom && this.form.value.is_feot_enabled;
  }

  public updateFeotPacing() {
    this.updatePayload({
      feot: {
        ...this.form.value.feot,
        interval: this.form.value.feot.interval,
      },
    });
    this._calculateFeotFields();
  }

  public updateFeotPacingInterval() {
    this.updatePayload({
      feot: {
        ...this.form.value.feot,
        interval: this.form.value.feot.interval,
      },
    });
    this._calculateFeotFields();
  }

  public feotPaceFormat(pace?: string, interval: number = 0) {
    if (!pace) {
      pace = this.form.value.feot.pacing;
    }
    if (!interval) {
      interval = this.form.value.feot.interval;
    }
    return interval > 1 ? pace : this.feotPaceSingular();
  }

  public feotPacePlural() {
    return this.feotFields.feotQuantity > 1 ? 's' : '';
  }

  public feotPaceSingular() {
    const { pacing: pace } = this.form.value.feot;
    return pace?.substring(0, pace.length - 1);
  }

  private _clearFilterByDateRange() {
    if (this.filterDateRange.start && this.filterDateRange.end) {
      this.filterDateRange = {};
      this._setCurrentDateRangePicker();
      this._toastr.warning(
        notifyMessage.warningMessage.EXCLUSION.REMOVE_SURVEY_NUMBER
      );
    }
  }

  private _setFilterDateRange() {
    const { start, end } = this.surveyDatails.feasibility_exclusions || {};
    if (start) {
      this.filterDateRange.start = this._momentApiCaller(moment, start)
        .tz(moment.tz.guess())
        .format('YYYY-MM-DD');
      this._dateRangeFilterRef?.datePicker.setStartDate(
        this._momentApiCaller(moment, start)
      );
    }
    if (end) {
      this.filterDateRange.end = this._momentApiCaller(moment, end)
        .tz(moment.tz.guess())
        .format('YYYY-MM-DD');
      this._dateRangeFilterRef?.datePicker.setEndDate(
        this._momentApiCaller(moment, end)
      );
    }
  }

  private _momentApiCaller(momentLib: any, ...props: unknown[]) {
    return 'default' in momentLib
      ? momentLib.default(...props)
      : momentLib(...props);
  }

  public copyToClipboard = (text: string) => {
    this.showSuccessTooltip = true;
    navigator.clipboard.writeText(text);
    setTimeout(() => {
      this.showSuccessTooltip = false;
    }, 2000);
  };

  private _validatePayload(payload: IncludePostPayload) {
    if (!((payload.fromDate && payload.toDate) || payload.surveyIds?.length)) {
      this._includePsids = [];
      this.surveyGroupingPSIDUpload = false;
      this.form.patchValue({ survey_grouping: [] });
      this._updateSurveyData();
      return false;
    }
    return true;
  }

  public handleEditBasicToken(show: boolean = true) {
    this.notEditableBasicToken = show;
    if (!show) {
      this.basicToken.nativeElement.focus();
    } else {
      this.form.patchValue({
        basic_token: {
          enable: true,
          value: this.fixedBasicTokenValue,
        },
      });
    }
  }

  private _setCurrentDateRangePicker() {
    const currentDate = this._momentApiCaller(moment, Date.now()).tz(
      moment.tz.guess()
    );
    this._dateRangeFilterRef?.datePicker.setStartDate(currentDate);
    this._dateRangeFilterRef?.datePicker.setEndDate(currentDate);
  }

  validateBillingCode() {
    const buyer_company = this.surveyPayload.buyer_company || 0;
    if (!this.form.value.billing_id) {
      return;
    }
    this._buyerApiService
      .serachBuyerSurveys(
        SurveyStatus.Invoice,
        this.form.value.billing_id,
        buyer_company,
        true
      )
      .subscribe(
        (invoicedSurveys: BuyerSurveyResponse[]) => {
          invoicedSurveys = invoicedSurveys.filter(
            (invoicedSurvey) =>
              invoicedSurvey.billing_id != this.surveyDatails.billing_id
          );
          if (invoicedSurveys.length > 0) {
            this._toastr.warning(
              notifyMessage.warningMessage.LAUNCH_SURVEY
                .BILLING_CODE_ALREADY_USED
            );
          }
        },
        (err) => {
          this._toastr.error(err.error.msg);
        }
      );
  }

  updateDqSetting(setting: string, value: boolean) {
    this.form.patchValue({
      dq_settings: {
        [setting]: value,
      },
    });
    this._updateDataQualityPayload();
  }

  private _updateDataQualityPayload() {
    this.updatePayload({
      dq_settings: {
        purescore_filter_enabled:
          this.form.value.dq_settings.purescore_filter_enabled,
        fp_device_check: this.form.value.dq_settings.fp_device_check,
        fp_fraud_check: this.form.value.dq_settings.fp_fraud_check,
      },
    });
  }

  ngOnDestroy() {
    this._missingMarkerModelRef?.close();
    this._subscriptions.unsubscribe();
  }
}

export interface QbpSelectionQuota {
  category: string;
  name: string;
  selectedQuotaIds: Array<string>;
}
